import React from "react"
import { Query } from "react-apollo"
import { Scrollbars } from "react-custom-scrollbars"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import { getNewsletterRedirect, getResearchRoutes } from "./queries"
import { lightLogo } from "../../shared/images"
import AppContext from "../../shared/AppContext"
import {
  MATCH_ROUTE_REGEX,
  DATA_TYPE,
  PATHNAMES,
} from "../../constants/sidebarRoutes"
import { BsStars } from "react-icons/bs"
import { BetaWaitlist } from "../BetaWaitlist"
import { SideBarNavLink, SubmenuArrowIcon } from "./components/SideBarNavLink"

import "./sideBar.scss"

class SideBar extends React.Component {
  static contextType = AppContext

  constructor(props) {
    super(props)
    this.state = {
      mobileSidebarOpen: false,
    }
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.location !== prevProps.location &&
      this.state.mobileSidebarOpen
    ) {
      this.setState({ mobileSidebarOpen: false })
    }
  }

  toggleMobileSideBar = () => {
    this.setState((state) => ({
      mobileSidebarOpen: !state.mobileSidebarOpen,
    }))
  }

  renderMobileComponents = () => {
    return (
      <>
        <div id="mobile-menu-close" onClick={this.toggleMobileSideBar}>
          <span className="icon-close" /> Close
        </div>
      </>
    )
  }

  renderSubmenuLinks = (submenuItems = []) => {
    const { props, context } = this
    return submenuItems.map((subnav, idx) => {
      const { text, isExternal, trackingName, ...navLinkProps } = subnav

      if (isExternal) {
        return (
          <Link href={subnav.to} target="_blank" className="sidebar-link sub">
            {text}
          </Link>
        )
      } else {
        return (
          <SideBarNavLink
            key={idx}
            {...navLinkProps}
            linkClass="sub"
            onClick={() => {
              context.trackEvent("Subnavigation Link", {
                link: props.location.pathname,
                name: trackingName,
                location: "Navigation Menu",
              })
            }}
            data-cy={text}
          >
            <span className="sideBar-link-name">{text}</span>
          </SideBarNavLink>
        )
      }
    })
  }

  renderNewsletterSubmenu = () => {
    const { redirect, location } = this.props
    const redirectMatch = "^" + redirect + "$"

    const newsletterPath =
      !!location.pathname.match(MATCH_ROUTE_REGEX.CURRENT_NEWSLETTER) ||
      !!location.pathname.match(new RegExp(redirectMatch, "i"))

    const submenuItems = [
      {
        text: "CURRENT NEWSLETTER",
        to: "/newsletter",
        isActive: () => !!newsletterPath,
        trackingName: "Current Newsletter",
      },
      {
        text: "ARCHIVE",
        exact: true,
        to: "/newsletters/archive",
        trackingName: "Newsletters Archive",
      },
    ]

    return this.renderSubmenuLinks(submenuItems)
  }

  renderEtrInsightsSubmenu = () => {
    const submenuItems = [
      {
        text: "ABOUT ETR INSIGHTS",
        to: "/etr-insights/about",
        trackingName: "About ETR INSIGHTS",
        "data-cy": "venn-nav-about",
      },
      {
        text: "CALENDAR",
        to: "/etr-insights/calendar",
        trackingName: "ETR Insights Calendar",
        "data-cy": "venn-nav-calendar",
      },
      {
        text: "TRANSCRIPT SEARCH",
        to: "/etr-insights/search",
        trackingName: "ETR Insights Transcript Search",
        "data-cy": "venn-nav-transcript-search",
      },
    ]

    return this.renderSubmenuLinks(submenuItems)
  }

  renderResearchRoutes = (dataType = "", routes = []) => {
    const drillDownModelsPath = !!this.props.location.pathname.match(
      MATCH_ROUTE_REGEX.MODELS,
      "i"
    )

    let submenuItems = []

    if (dataType.toLowerCase() === PATHNAMES.ETS) {
      submenuItems = [
        {
          text: "ABOUT ETS",
          exact: true,
          to: "/ets",
          trackingName: "About ETS",
        },
      ]
    }

    if (dataType.toLowerCase() === PATHNAMES.DRILLDOWNS) {
      submenuItems = [
        {
          text: "ABOUT DRILL DOWNS",
          exact: true,
          to: "/research/drill-downs",
          trackingName: "About Drill Downs",
          "data-cy": "dd-nav-about",
        },
        {
          text: "MODELS",
          isActive: () => !!drillDownModelsPath,
          to: "/drill-downs",
          trackingName: "Search Drill Downs",
        },
      ]
    }

    if (dataType.toLowerCase() === PATHNAMES.TSIS) {
      submenuItems = [
        {
          text: "ABOUT TSIS",
          exact: true,
          to: "/research/tsis",
          trackingName: "About TSIS",
        },
      ]
    }

    if (this.props.viewer.isUserAuthenticated) {
      routes.map((researchRoutes) => {
        const location = this.props.location.pathname.toLowerCase()
        const researchPath = researchRoutes.path.toLowerCase()
        const researchName = researchRoutes.chapters[0].path.toLowerCase()
        if (researchPath !== PATHNAMES.RESEARCH_COVERAGE) {
          if (researchPath !== "drill-downs") {
            submenuItems.push({
              text: researchRoutes.displayName,
              to: `/${dataType}/${researchPath}/${researchName}`,
              exact: false,
              isActive: () =>
                !!location.match(`/${dataType}/${researchPath}/`, "i"),
              trackingName: researchPath,
            })
          }
        }
      })
    }

    return this.renderSubmenuLinks(submenuItems)
  }

  renderAdminRoutes(dataPath, routes = []) {
    let submenuItems = []

    routes.map((route, idx) => {
      const routePath = route.path.toLowerCase()
      const chapterPath = route.chapters[idx].path.toLowerCase()

      submenuItems.push({
        text: route.displayName,
        to: `/${dataPath}/${routePath}/${chapterPath}`,
        exact: false,
      })
    })

    submenuItems.push({
      text: "GO TO ADMIN",
      to: "/admin",
      target: "__blank",
    })

    return this.renderSubmenuLinks(submenuItems)
  }

  getFirstLink = (datasetPath, routes = []) => {
    const firstDataRoute = routes[0]
    let firstRoutePath = firstDataRoute.path.toLowerCase()
    let firstChapterPath = firstDataRoute.chapters[0].path.toLowerCase()

    return `/${datasetPath}/${firstRoutePath}/${firstChapterPath}`
  }

  hasRoleOrAdminRoles = (userRole) => {
    if (this.props && this.props.viewer && this.props.viewer.roles)
      return this.props.viewer.roles.some(
        (role) =>
          role === userRole ||
          role === "ETR Master Admin" ||
          role === "ETR Research Admin" ||
          role === "ETR Sales Admin"
      )
  }

  renderNavLinks = () => {
    const { props, context } = this
    const { viewer, location } = props
    const { isUserAuthenticated } = viewer

    const isNewsletter = !!location.pathname.match(MATCH_ROUTE_REGEX.NEWSLETTER)
    const isMyFavorite = !!location.pathname.match(
      MATCH_ROUTE_REGEX.MY_FAVORITES
    )
    const isEtrInsights = !!location.pathname.match(
      MATCH_ROUTE_REGEX.ETR_INSIGHTS
    )
    const isEts = !!location.pathname.match(MATCH_ROUTE_REGEX.ETS)
    const isTsis = !!location.pathname.match(MATCH_ROUTE_REGEX.TSIS)
    const isDrilldown =
      !!location.pathname.match(MATCH_ROUTE_REGEX.DRILLDOWNS) ||
      !!location.pathname.match("/drill-downs")
    const isAdmin = !!location.pathname.match(MATCH_ROUTE_REGEX.ADMIN)

    return (
      <>
        <nav className="sidebar-links-container">
          <SideBarNavLink
            data-cy="sidebar-home"
            exact
            to="/"
            onClick={() =>
              context.trackEvent("Navigation Link", {
                link: location.pathname,
                name: "Home",
                location: "Navigation Menu",
              })
            }
          >
            <span className="nav-icon left-icon glyphicon glyphicon-home"></span>
            <span className="sideBar-link-name">HOME</span>
          </SideBarNavLink>

          <SideBarNavLink
            data-cy="sidebar-newsletter"
            to={`/${PATHNAMES.NEWSLETTER}`}
            isActive={() => isNewsletter}
            onClick={() =>
              context.trackEvent("Navigation Link", {
                link: location.pathname,
                name: "Newsletter",
                location: "Navigation Menu",
              })
            }
          >
            <span className="nav-icon left-icon glyphicon glyphicon-envelope"></span>
            <span className="sideBar-link-name">NEWSLETTER</span>
            <SubmenuArrowIcon isSubmenuOpen={isNewsletter} />
          </SideBarNavLink>
          {isNewsletter && this.renderNewsletterSubmenu()}

          <SideBarNavLink
            data-cy="sidebar-marketplace"
            to="/marketplace"
            onClick={() =>
              context.trackEvent("Navigation Link", {
                link: location.pathname,
                name: "Reports",
                location: "Navigation Menu",
              })
            }
          >
            <span className="nav-icon left-icon glyphicon glyphicon-duplicate"></span>
            <span className="sideBar-link-name">REPORTS</span>
          </SideBarNavLink>

          <SideBarNavLink
            data-cy="sidebar-my-favorites"
            to={`/${PATHNAMES.MY_FAVORITES}`}
            isActive={() => isMyFavorite}
            onClick={() =>
              context.trackEvent("Navigation Link", {
                link: location.pathname,
                name: "MY FAVORITES",
                location: "Navigation Menu",
              })
            }
          >
            <span className="nav-icon left-icon icon-favorite"></span>
            <span className="sideBar-link-name">MY FAVORITES</span>
          </SideBarNavLink>
          <Query query={getResearchRoutes} fetchPolicy={"cache-and-network"}>
            {(results) => {
              if (results && results.data) {
                const { data } = results
                const hasRouteType = (routeType) =>
                  !!data[routeType] && !!data[routeType].length

                let topMenuTsisLink = ""
                let topMenuAdminLink = ""

                if (hasRouteType(DATA_TYPE.TSIS)) {
                  topMenuTsisLink = this.getFirstLink(
                    PATHNAMES.TSIS,
                    data[DATA_TYPE.TSIS]
                  )
                }

                if (hasRouteType(DATA_TYPE.ADMIN)) {
                  topMenuAdminLink = this.getFirstLink(
                    PATHNAMES.ADMIN,
                    data[DATA_TYPE.ADMIN]
                  )
                }

                const researchCoverageRoute =
                  data &&
                  data.tsisRoutes &&
                  data.tsisRoutes.find((route) => {
                    return (
                      route.path.toLowerCase() == PATHNAMES.RESEARCH_COVERAGE
                    )
                  })

                return (
                  <>
                    <SideBarNavLink
                      data-cy="sidebar-tsis-dropdown"
                      to={
                        this.hasRoleOrAdminRoles("TSIS")
                          ? topMenuTsisLink
                          : `/${PATHNAMES.TSIS_ABOUT}`
                      }
                      isActive={() => isTsis}
                      onClick={() =>
                        context.trackEvent("Navigation Link", {
                          link: location.pathname,
                          name: "TSIS",
                          location: "Navigation Menu",
                        })
                      }
                    >
                      <span className="nav-icon left-icon glyphicon glyphicon-stats"></span>
                      <span className="sideBar-link-name">
                        TSIS <br />
                        <sub className="no-phone-display">
                          TECHNOLOGY SPENDING <br />
                          INTENTIONS SURVEY{" "}
                        </sub>
                      </span>
                      {isUserAuthenticated && (
                        <SubmenuArrowIcon isSubmenuOpen={isTsis} />
                      )}
                    </SideBarNavLink>
                    {isUserAuthenticated &&
                      hasRouteType(DATA_TYPE.TSIS) &&
                      isTsis &&
                      this.renderResearchRoutes("research", data.tsisRoutes)}
                    <SideBarNavLink
                      data-cy="sidebar-ets-dropdown"
                      to={
                        this.hasRoleOrAdminRoles("ETS")
                          ? `/${PATHNAMES.ETR_SURVEYS}`
                          : `/${PATHNAMES.ETS}`
                      }
                      isActive={() => isEts}
                      onClick={() =>
                        context.trackEvent("Navigation Link", {
                          link: location.pathname,
                          name: "ETS",
                          location: "Navigation Menu",
                        })
                      }
                    >
                      <span className="nav-icon left-icon icon-ets"></span>
                      <span className="sideBar-link-name">
                        ETS <br />
                        <sub className="no-phone-display">
                          EMERGING TECHNOLOGY SURVEY{" "}
                        </sub>
                      </span>
                      <SubmenuArrowIcon isSubmenuOpen={isEts} />
                    </SideBarNavLink>
                    {hasRouteType(DATA_TYPE.ETS) &&
                      isEts &&
                      this.renderResearchRoutes("ets", data.etsRoutes)}
                    {isUserAuthenticated &&
                      hasRouteType(DATA_TYPE.DRILLDOWNS) && (
                        <SideBarNavLink
                          data-cy="sidebar-drill-downs"
                          to={
                            this.hasRoleOrAdminRoles("DrillDowns")
                              ? "/drill-downs"
                              : "/research/drill-downs"
                          }
                          isActive={() => isDrilldown}
                          onClick={() =>
                            context.trackEvent("Navigation Link", {
                              link: location.pathname,
                              name: "Drilldowns",
                              location: "Navigation Menu",
                            })
                          }
                        >
                          <span className="nav-icon left-icon glyphicon glyphicon-sort-by-attributes-alt"></span>
                          <span className="sideBar-link-name">DRILL DOWNS</span>
                          <SubmenuArrowIcon isSubmenuOpen={isDrilldown} />
                        </SideBarNavLink>
                      )}
                    {hasRouteType(DATA_TYPE.DRILLDOWNS) &&
                      isDrilldown &&
                      this.renderResearchRoutes(
                        "drill-downs",
                        data.drilldownsRoutes
                      )}
                    {/* <SideBarNavLink
                      data-cy="sidebar-market-array"
                      to="/market-array"
                    >
                      <span className="nav-icon left-icon icon-etr-market-array"></span>
                      <span className="sideBar-link-name">MARKET ARRAY</span>
                    </SideBarNavLink> */}

                    <SideBarNavLink
                      data-cy="sidebar-observatory-bundles"
                      to="/observatory-bundles"
                      onClick={() =>
                        context.trackEvent("Navigation Link", {
                          link: location.pathname,
                          name: "Observatory Bundles",
                          location: "Navigation Menu",
                        })
                      }
                    >
                      <span className="nav-icon left-icon glyphicon glyphicon-folder-open"></span>
                      <span className="sideBar-link-name">
                        OBSERVATORY BUNDLES
                      </span>
                    </SideBarNavLink>

                    <SideBarNavLink
                      data-cy="sidebar-ai-product-series"
                      to="/ai-product-series"
                      onClick={() =>
                        context.trackEvent("Navigation Link", {
                          link: location.pathname,
                          name: "AI Product Series",
                          location: "Navigation Menu",
                        })
                      }
                    >
                      <span className="nav-icon left-icon">
                        <BsStars />
                      </span>
                      <span className="sideBar-link-name">
                        AI PRODUCT SERIES
                      </span>
                    </SideBarNavLink>

                    <SideBarNavLink
                      data-cy="sidebar-venn"
                      to={`/${PATHNAMES.ETR_INSIGHTS}`}
                      onClick={() =>
                        context.trackEvent("Navigation Link", {
                          link: location.pathname,
                          name: "ETR INSIGHTS",
                          location: "Navigation Menu",
                        })
                      }
                    >
                      <span className="nav-icon left-icon icon-etr-insights"></span>
                      <span className="sideBar-link-name">ETR INSIGHTS</span>
                      <SubmenuArrowIcon isSubmenuOpen={isEtrInsights} />
                    </SideBarNavLink>
                    {isEtrInsights && this.renderEtrInsightsSubmenu()}
                    {isUserAuthenticated && hasRouteType(DATA_TYPE.TSIS) && (
                      <SideBarNavLink
                        data-cy="sidebar-community"
                        to={`/research/${
                          researchCoverageRoute.path
                        }/${researchCoverageRoute.chapters[0].path.toLowerCase()}`}
                        onClick={() =>
                          context.trackEvent("Navigation Link", {
                            link: location.pathname,
                            name: "Community",
                            location: "Navigation Menu",
                          })
                        }
                      >
                        <span className="nav-icon left-icon glyphicon icon-community"></span>
                        <span className="sideBar-link-name">
                          {researchCoverageRoute.displayName}
                        </span>
                      </SideBarNavLink>
                    )}
                    {isUserAuthenticated && hasRouteType(DATA_TYPE.ADMIN) && (
                      <SideBarNavLink
                        to={topMenuAdminLink}
                        isActive={() => isAdmin}
                        onClick={() =>
                          context.trackEvent("Navigation Link", {
                            link: location.pathname,
                            name: "Admin",
                            location: "Navigation Menu",
                          })
                        }
                      >
                        <span className="nav-icon left-icon glyphicon glyphicon-certificate"></span>
                        <span className="sideBar-link-name">ADMIN</span>
                        <SubmenuArrowIcon isSubmenuOpen={isAdmin} />
                      </SideBarNavLink>
                    )}
                    {hasRouteType(DATA_TYPE.ADMIN) &&
                      isAdmin &&
                      this.renderAdminRoutes("admin-bi", data.adminRoutes)}
                  </>
                )
              }
            }}
          </Query>
          {/* Hide the waitlist for now...
          {!this.props.viewer.joinedBetaWaitlist && (
            <BetaWaitlist type="banner" viewer={viewer} />
          )} */}
        </nav>
        <footer className="sidebar-policy-container">
          <a href="https://etr.ai/term-of-use" target="_blank" rel="noreferrer">
            Terms of Use
          </a>
          <a
            href="https://etr.ai/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          <Link to="/help">Help</Link>
        </footer>
      </>
    )
  }

  render = () => {
    return (
      <aside
        data-cy="sidebar-nav"
        className={`sidebar-container ${
          this.state.mobileSidebarOpen ? "active" : ""
        }`}
      >
        <Scrollbars
          universal
          className="custom-scrollbars"
          renderThumbVertical={({ style, ...props }) => (
            <div
              {...props}
              style={{ ...style, backgroundColor: "#fff", opacity: "0.5" }}
            />
          )}
        >
          <header className="sidebar-header">
            <Link to="/">
              <img src={lightLogo} alt="ETR" />
            </Link>
          </header>
          {this.renderMobileComponents()}
          {this.renderNavLinks()}
        </Scrollbars>
      </aside>
    )
  }
}

const SideBarWithData = (componentProps) => {
  return (
    <Query query={getNewsletterRedirect} fetchPolicy="network-only">
      {(props) => {
        const { data, client } = props
        return (
          <SideBar
            {...componentProps}
            redirect={data && data.newsletterRedirect}
            client={client}
          />
        )
      }}
    </Query>
  )
}

export default withRouter(SideBarWithData)
